export default "__VITE_ASSET__lsBrIW0p__"